import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface DashboardCardProps {
  title: string;
  value: number | string;
  icon: LucideIcon;
  color: string;
  loading?: boolean;
  change?: {
    value: number;
    type: 'increase' | 'decrease';
  };
}

export default function DashboardCard({ 
  title, 
  value, 
  icon: Icon, 
  color, 
  loading = false,
  change 
}: DashboardCardProps) {
  return (
    <div className="bg-white p-6 rounded-xl shadow-elevation-1 hover:shadow-elevation-2 transition-shadow">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-gray-600 text-sm">{title}</p>
          <p className="text-2xl font-bold mt-2">
            {loading ? (
              <div className="h-8 w-24 bg-gray-200 rounded animate-pulse" />
            ) : (
              value
            )}
          </p>
          {change && !loading && (
            <div className={`flex items-center mt-2 text-sm ${
              change.type === 'increase' ? 'text-green-600' : 'text-red-600'
            }`}>
              <span>{change.type === 'increase' ? '↑' : '↓'}</span>
              <span className="ml-1">{Math.abs(change.value)}%</span>
              <span className="ml-1 text-gray-500">vs. mês anterior</span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-xl ${color}`}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
    </div>
  );
}